import Swiper, { Lazy, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/lazy';


function initializeSliderProcampoRedesSociais(containerId) {
    const containerSlider = $(containerId);

    

    const swiperRedesSociais = new Swiper(containerId + ' .swiper-no-padding ', {
        modules: [Navigation, Lazy],
        allowTouchMove: true,
        slidesPerView: 'auto',

        breakpoints: {
            0: {
                spaceBetween: 8,                
            },
            //md
            768: {
                spaceBetween: 24,
            },
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

       
    });
    
}

$(function () {
    $('.slider-procampo-redes-sociais').each(function () {
        initializeSliderProcampoRedesSociais('#' + $(this).attr('id'));
    });
});
